import Vue from 'vue'
import grid from './grid.vue'
import edit from './edit.vue'
import select from './select.vue'

Vue.component('app-acessotela-grid', grid)
Vue.component('app-acessotela-edit', edit)
Vue.component('app-acessotela-select', select)
